"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: white;\n  border-radius: 7px;\n  padding: 30px;\n  min-width: 350px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: red;\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Introduction = exports.Title = exports.Form = exports.Error = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var Error = styled_components_1.default.p(_templateObject());
exports.Error = Error;
var Form = styled_components_1.default.form(_templateObject2());
exports.Form = Form;
var Title = styled_components_1.default.h2(_templateObject3());
exports.Title = Title;
var Introduction = styled_components_1.default.p(_templateObject4());
exports.Introduction = Introduction;